export function urlFormat(value) {
    return (value
        .replace(/[^0-9a-zA-Z_\s\-]/g, '')
        .replace(/\s+/g, '-')
        .toLocaleLowerCase());
}
export function assertUndefinedOrNonEmpty(value) {
    if (value !== undefined && value.length === 0) {
        throw new Error(`Provided string was empty. Expected undefined XOR non-empty string.`);
    }
    return value;
}
//# sourceMappingURL=StringUtilities.js.map